import { Component, type ReactNode } from "react";
import { logger } from "@/lib/logger";
import { Button } from "@/components/ui/button";

interface State { hasError: boolean }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: { componentStack?: string | null }) {
    logger.error("react_error_boundary", { error: String(error), stack: info.componentStack ?? "" });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-4 bg-background p-6 text-center">
          <h1 className="text-xl font-semibold">Der opstod en fejl</h1>
          <p className="text-muted-foreground">Prøv at genindlæse siden. Fejlen er registreret.</p>
          <Button onClick={() => window.location.reload()}>Genindlæs</Button>
        </div>
      );
    }
    return this.props.children;
  }
}
